module.exports = __webpack_public_path__ + "static/img/romi.0a018f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/romi.jpg
// module id = yrOY
// module chunks = 0